if (!customElements.get('pups-group-order-builder')) {
  customElements.define(
    'pups-group-order-builder',
    class PupsGroupOrderBuilder extends HTMLElement {
      connectedCallback() {
        this.data = JSON.parse(this.querySelector('[data-group-order-data]').textContent);
        this.labels = this.data.labels;
        this.designs = this.data.designs;
        this.items = [];
        this.cache = new Map();
        this.editingIndex = null;
        this.prefilled = false;

        this.toggle = this.querySelector('[data-group-order-toggle]');
        this.panel = this.querySelector('[data-group-order-panel]');
        this.form = this.querySelector('[data-group-order-form]');
        this.search = this.querySelector('[data-dog-search]');
        this.dogSelect = this.querySelector('[data-dog-select]');
        this.saying = this.querySelector('[data-shirt-saying]');
        this.sayingText = this.querySelector('[data-shirt-saying-text]');
        this.garmentSelect = this.querySelector('[data-garment-select]');
        this.colorSelect = this.querySelector('[data-color-select]');
        this.sizeSelect = this.querySelector('[data-size-select]');
        this.quantity = this.querySelector('[data-quantity]');
        this.addRowButton = this.querySelector('[data-add-row]');
        this.selectionPreview = this.querySelector('[data-selection-preview]');
        this.selectionImage = this.querySelector('[data-selection-image]');
        this.selectionTitle = this.querySelector('[data-selection-title]');
        this.selectionPrice = this.querySelector('[data-selection-price]');
        this.itemsList = this.querySelector('[data-group-items]');
        this.emptyMessage = this.querySelector('[data-empty-message]');
        this.footer = this.querySelector('[data-group-footer]');
        this.total = this.querySelector('[data-group-total]');
        this.addGroupButton = this.querySelector('[data-add-group]');
        this.status = this.querySelector('[data-group-status]');
        this.galleryImage = this.findGalleryImage();
        this.originalGalleryImage = this.snapshotImage(this.galleryImage);

        this.garments = [
          ['comfort-colors-tee', 'Comfort Colors® T-Shirt'],
          ['softstyle-tee', 'Gildan Softstyle® T-Shirt'],
          ['crewneck-sweatshirt', 'Gildan Heavy Blend™ Sweatshirt'],
          ['comfort-colors-sweatshirt', 'Comfort Colors® Sweatshirt'],
        ];
        this.garmentKeys = {
          'Comfort Colors Tee': 'comfort-colors-tee',
          'Softstyle Tee': 'softstyle-tee',
          'Crewneck Sweatshirt': 'crewneck-sweatshirt',
          'Comfort Colors Sweatshirt': 'comfort-colors-sweatshirt',
        };

        this.populateDogs();
        this.bindEvents();
      }

      bindEvents() {
        this.toggle.addEventListener('click', () => this.togglePanel());
        this.search.addEventListener('input', () => this.filterDogs());
        this.dogSelect.addEventListener('change', () => this.onDogChange());
        this.garmentSelect.addEventListener('change', () => this.loadSelectedProduct());
        this.colorSelect.addEventListener('change', () => this.onColorChange());
        this.sizeSelect.addEventListener('change', () => this.updateSelection());
        this.form.addEventListener('submit', (event) => this.addOrUpdateRow(event));
        this.addGroupButton.addEventListener('click', () => this.addGroupToCart());
      }

      populateDogs() {
        const selected = this.dogSelect.value;
        this.dogSelect.length = 1;
        for (const design of this.designs) {
          const option = document.createElement('option');
          option.value = design.name;
          option.textContent = design.name;
          this.dogSelect.append(option);
        }
        if (this.designs.some((design) => design.name === selected)) this.dogSelect.value = selected;
      }

      filterDogs() {
        const query = this.search.value.trim().toLocaleLowerCase();
        for (const option of [...this.dogSelect.options].slice(1)) {
          option.hidden = query.length > 0 && !option.textContent.toLocaleLowerCase().includes(query);
        }
      }

      async togglePanel() {
        const opening = this.panel.hidden;
        this.panel.hidden = !opening;
        this.toggle.setAttribute('aria-expanded', String(opening));
        if (opening && !this.prefilled) {
          this.prefilled = true;
          await this.prefillCurrentProduct();
        }
        if (opening && this.prefilled) this.syncCurrentGalleryImage();
        if (opening) this.panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        else this.restoreGalleryImage();
      }

      async prefillCurrentProduct() {
        const currentDog = this.dataset.currentDog;
        const currentGarment = this.garmentKeys[this.dataset.currentGarment];
        if (!currentDog || !currentGarment || !this.designs.some((design) => design.name === currentDog)) return;
        this.dogSelect.value = currentDog;
        this.onDogChange(false);
        this.garmentSelect.value = currentGarment;
        await this.loadSelectedProduct(false);

        const productForm = document.querySelector(`product-form form[action*="/cart/add"] input[name="id"]`);
        const variantId = Number(productForm?.value);
        const variant = this.currentProduct?.variants?.find((item) => Number(item.id) === variantId)
          || this.currentProduct?.variants?.find((item) => item.available);
        if (!variant) return;
        const indexes = this.optionIndexes(this.currentProduct);
        this.colorSelect.value = variant.options[indexes.color];
        this.onColorChange(false);
        this.sizeSelect.value = variant.options[indexes.size];
        this.updateSelection();
      }

      onDogChange(reset = true) {
        const design = this.currentDesign();
        const saying = design?.saying?.trim();
        if (saying) {
          const punctuatedSaying = /[.!?]$/.test(saying) ? saying : `${saying}.`;
          this.sayingText.textContent = `“${punctuatedSaying}”`;
          this.saying.hidden = false;
        } else {
          this.sayingText.textContent = '';
          this.saying.hidden = true;
        }
        this.garmentSelect.length = 1;
        for (const [key, label] of this.garments) {
          if (!design?.products?.[key]?.handle) continue;
          const option = document.createElement('option');
          option.value = key;
          option.textContent = label;
          this.garmentSelect.append(option);
        }
        this.garmentSelect.disabled = !design;
        if (reset) this.resetProductFields();
        if (!design) {
          this.restoreGalleryImage();
          return;
        }
        const defaultProduct = this.garments
          .map(([key]) => design.products?.[key])
          .find((product) => product?.image);
        this.syncGalleryImage(defaultProduct?.image, `${design.name} Smoking Santa shirt`);
      }

      currentDesign() {
        return this.designs.find((design) => design.name === this.dogSelect.value);
      }

      resetProductFields() {
        this.currentProduct = null;
        this.currentVariant = null;
        this.resetSelect(this.colorSelect);
        this.resetSelect(this.sizeSelect);
        this.selectionPreview.hidden = true;
        this.addRowButton.disabled = true;
      }

      resetSelect(select) {
        select.length = 1;
        select.disabled = true;
      }

      async loadSelectedProduct(reset = true) {
        const design = this.currentDesign();
        const productRef = design?.products?.[this.garmentSelect.value];
        this.resetProductFields();
        if (!productRef?.handle) return;
        this.setStatus(this.labels.loading);
        this.garmentSelect.disabled = true;
        try {
          this.currentProduct = await this.fetchProduct(productRef.handle);
          this.syncGalleryImage(
            this.productImage(this.currentProduct) || productRef.image,
            `${design.name} ${this.garmentLabel(this.garmentSelect.value)}`,
          );
          this.populateColors();
          if (reset) this.colorSelect.focus();
          this.setStatus('');
        } catch (error) {
          console.error(error);
          this.setStatus(this.labels.error, true);
        } finally {
          this.garmentSelect.disabled = false;
        }
      }

      async fetchProduct(handle) {
        if (this.cache.has(handle)) return this.cache.get(handle);
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}products/${encodeURIComponent(handle)}.js`, { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error(`Product request failed (${response.status}).`);
        const product = await response.json();
        this.cache.set(handle, product);
        return product;
      }

      optionIndexes(product) {
        const names = product.options.map((option) => String(typeof option === 'string' ? option : option.name).toLocaleLowerCase());
        return { color: names.indexOf('color'), size: names.indexOf('size') };
      }

      populateColors() {
        this.resetSelect(this.colorSelect);
        this.resetSelect(this.sizeSelect);
        const indexes = this.optionIndexes(this.currentProduct);
        if (indexes.color < 0 || indexes.size < 0) throw new Error('Expected Color and Size product options.');
        const colors = [...new Set(this.currentProduct.variants.map((variant) => variant.options[indexes.color]))];
        for (const color of colors) {
          const option = document.createElement('option');
          option.value = color;
          option.textContent = color;
          this.colorSelect.append(option);
        }
        this.colorSelect.disabled = false;
      }

      onColorChange(focus = true) {
        this.resetSelect(this.sizeSelect);
        this.currentVariant = null;
        this.selectionPreview.hidden = true;
        this.addRowButton.disabled = true;
        if (!this.currentProduct || !this.colorSelect.value) return;
        const indexes = this.optionIndexes(this.currentProduct);
        const variants = this.currentProduct.variants.filter((variant) => variant.options[indexes.color] === this.colorSelect.value);
        const sizes = [...new Set(variants.map((variant) => variant.options[indexes.size]))];
        for (const size of sizes) {
          const available = variants.some((variant) => variant.options[indexes.size] === size && variant.available);
          const option = document.createElement('option');
          option.value = size;
          option.textContent = available ? size : `${size} — ${this.labels.soldOut}`;
          option.disabled = !available;
          this.sizeSelect.append(option);
        }
        this.sizeSelect.disabled = false;
        const previewVariant = variants.find((variant) => variant.available) || variants[0];
        const design = this.currentDesign();
        this.syncGalleryImage(
          this.variantImage(previewVariant) || this.productImage(this.currentProduct),
          `${design.name} ${this.garmentLabel(this.garmentSelect.value)} in ${this.colorSelect.value}`,
        );
        if (focus) this.sizeSelect.focus();
      }

      updateSelection() {
        if (!this.currentProduct || !this.colorSelect.value || !this.sizeSelect.value) return;
        const indexes = this.optionIndexes(this.currentProduct);
        this.currentVariant = this.currentProduct.variants.find((variant) =>
          variant.available
          && variant.options[indexes.color] === this.colorSelect.value
          && variant.options[indexes.size] === this.sizeSelect.value
        );
        if (!this.currentVariant) {
          this.selectionPreview.hidden = true;
          this.addRowButton.disabled = true;
          return;
        }
        const design = this.currentDesign();
        const productRef = design.products[this.garmentSelect.value];
        const image = this.variantImage(this.currentVariant) || productRef.image;
        this.syncGalleryImage(
          image || this.productImage(this.currentProduct),
          `${design.name} ${this.garmentLabel(this.garmentSelect.value)} in ${this.colorSelect.value}`,
        );
        this.selectionImage.src = image || '';
        this.selectionTitle.textContent = `${design.name} · ${this.garmentLabel(this.garmentSelect.value)}`;
        this.selectionPrice.textContent = this.formatMoney(Number(this.currentVariant.price));
        this.selectionPreview.hidden = false;
        this.addRowButton.disabled = false;
      }

      variantImage(variant) {
        if (!variant) return null;
        if (typeof variant.featured_image === 'string') return variant.featured_image;
        return variant.featured_image?.src || variant.featured_image?.url || null;
      }

      productImage(product) {
        if (!product) return null;
        if (typeof product.featured_image === 'string') return product.featured_image;
        return product.featured_image?.src || product.images?.[0]?.src || product.images?.[0] || null;
      }

      findGalleryImage() {
        const gallery = document.getElementById(`MediaGallery-${this.dataset.sectionId}`);
        const activeSlide = gallery?.querySelector('.product__media-item.is-active')
          || gallery?.querySelector('.product__media-item');
        return activeSlide?.querySelector('.product__media img') || null;
      }

      snapshotImage(image) {
        if (!image) return null;
        return {
          src: image.getAttribute('src'),
          srcset: image.getAttribute('srcset'),
          alt: image.getAttribute('alt'),
        };
      }

      transformedImageUrl(image, width) {
        if (!image) return '';
        const normalized = String(image).startsWith('//') ? `${window.location.protocol}${image}` : String(image);
        try {
          const url = new URL(normalized, window.location.origin);
          url.searchParams.set('width', String(width));
          return url.toString();
        } catch (_) {
          return normalized;
        }
      }

      syncGalleryImage(image, alt) {
        if (!image) return;
        if (!this.galleryImage?.isConnected) {
          this.galleryImage = this.findGalleryImage();
          if (!this.originalGalleryImage) this.originalGalleryImage = this.snapshotImage(this.galleryImage);
        }
        if (!this.galleryImage) return;
        const widths = [493, 823, 1100, 1426, 1946];
        this.galleryImage.src = this.transformedImageUrl(image, 1426);
        this.galleryImage.srcset = widths
          .map((width) => `${this.transformedImageUrl(image, width)} ${width}w`)
          .join(', ');
        this.galleryImage.alt = alt || '';
        this.galleryImage.dataset.groupOrderPreview = 'true';
      }

      syncCurrentGalleryImage() {
        const design = this.currentDesign();
        if (!design) return;
        const garment = this.garmentLabel(this.garmentSelect.value);
        if (this.currentVariant) {
          this.syncGalleryImage(
            this.variantImage(this.currentVariant) || this.productImage(this.currentProduct),
            `${design.name} ${garment} in ${this.colorSelect.value}`,
          );
          return;
        }
        if (this.currentProduct) {
          const indexes = this.optionIndexes(this.currentProduct);
          const colorVariant = this.colorSelect.value
            ? this.currentProduct.variants.find((variant) => variant.available && variant.options[indexes.color] === this.colorSelect.value)
            : null;
          this.syncGalleryImage(
            this.variantImage(colorVariant) || this.productImage(this.currentProduct),
            this.colorSelect.value
              ? `${design.name} ${garment} in ${this.colorSelect.value}`
              : `${design.name} ${garment}`,
          );
          return;
        }
        const defaultProduct = this.garments
          .map(([key]) => design.products?.[key])
          .find((product) => product?.image);
        this.syncGalleryImage(defaultProduct?.image, `${design.name} Smoking Santa shirt`);
      }

      restoreGalleryImage() {
        if (!this.galleryImage || !this.originalGalleryImage) return;
        for (const [attribute, value] of Object.entries(this.originalGalleryImage)) {
          if (value === null) this.galleryImage.removeAttribute(attribute);
          else this.galleryImage.setAttribute(attribute, value);
        }
        delete this.galleryImage.dataset.groupOrderPreview;
      }

      garmentLabel(key) {
        return this.garments.find(([value]) => value === key)?.[1] || key;
      }

      addOrUpdateRow(event) {
        event.preventDefault();
        if (!this.currentVariant) return;
        const quantity = Math.max(1, Math.min(99, Number.parseInt(this.quantity.value, 10) || 1));
        const design = this.currentDesign();
        const row = {
          variantId: Number(this.currentVariant.id),
          dog: design.name,
          garmentKey: this.garmentSelect.value,
          garment: this.garmentLabel(this.garmentSelect.value),
          handle: this.currentProduct.handle,
          color: this.colorSelect.value,
          size: this.sizeSelect.value,
          quantity,
          price: Number(this.currentVariant.price),
          image: this.variantImage(this.currentVariant) || design.products[this.garmentSelect.value].image || '',
        };
        if (this.editingIndex === null) this.items.push(row);
        else this.items.splice(this.editingIndex, 1, row);
        this.editingIndex = null;
        this.addRowButton.textContent = this.labels.addShirt;
        this.quantity.value = '1';
        this.renderRows();
        this.setStatus('');
      }

      renderRows() {
        this.itemsList.replaceChildren();
        this.items.forEach((item, index) => this.itemsList.append(this.createRow(item, index)));
        this.emptyMessage.hidden = this.items.length > 0;
        this.footer.hidden = this.items.length === 0;
        const total = this.items.reduce((sum, item) => sum + item.price * item.quantity, 0);
        this.total.textContent = this.formatMoney(total);
      }

      createRow(item, index) {
        const row = document.createElement('li');
        row.className = 'pups-group-order__item';
        const image = document.createElement('img');
        image.src = item.image;
        image.alt = '';
        image.loading = 'lazy';
        image.width = 64;
        image.height = 64;
        const content = document.createElement('div');
        const title = document.createElement('p');
        title.className = 'pups-group-order__item-title';
        const strong = document.createElement('strong');
        strong.textContent = `${item.dog} · ${item.garment}`;
        title.append(strong);
        const details = document.createElement('p');
        details.className = 'pups-group-order__item-details';
        details.textContent = `${item.color} · ${item.size} · Qty ${item.quantity}`;
        const price = document.createElement('p');
        price.className = 'pups-group-order__item-price';
        price.textContent = this.formatMoney(item.price * item.quantity);
        const actions = document.createElement('div');
        actions.className = 'pups-group-order__item-actions';
        actions.append(
          this.actionButton(this.labels.edit, () => this.editRow(index)),
          this.actionButton(this.labels.duplicate, () => this.duplicateRow(index)),
          this.actionButton(this.labels.remove, () => this.removeRow(index)),
        );
        content.append(title, details, price, actions);
        row.append(image, content);
        return row;
      }

      actionButton(label, action) {
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = label;
        button.addEventListener('click', action);
        return button;
      }

      async editRow(index) {
        const item = this.items[index];
        if (!item) return;
        this.editingIndex = index;
        this.dogSelect.value = item.dog;
        this.onDogChange(false);
        this.garmentSelect.value = item.garmentKey;
        await this.loadSelectedProduct(false);
        this.colorSelect.value = item.color;
        this.onColorChange(false);
        this.sizeSelect.value = item.size;
        this.quantity.value = String(item.quantity);
        this.updateSelection();
        this.addRowButton.textContent = this.labels.save;
        this.form.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }

      duplicateRow(index) {
        const item = this.items[index];
        if (!item) return;
        this.items.splice(index + 1, 0, { ...item });
        this.renderRows();
      }

      removeRow(index) {
        this.items.splice(index, 1);
        if (this.editingIndex === index) {
          this.editingIndex = null;
          this.addRowButton.textContent = this.labels.addShirt;
        }
        this.renderRows();
      }

      formatMoney(cents) {
        const currency = window.Shopify?.currency?.active || 'USD';
        try {
          return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(cents / 100);
        } catch (_) {
          return `$${(cents / 100).toFixed(2)}`;
        }
      }

      async addGroupToCart() {
        if (!this.items.length || this.addGroupButton.disabled) return;
        const grouped = new Map();
        for (const item of this.items) grouped.set(item.variantId, (grouped.get(item.variantId) || 0) + item.quantity);
        const items = [...grouped].map(([id, quantity]) => ({ id, quantity }));
        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const payload = { items };
        const linesUpdateDeferred = this.createCartLinesUpdateEvent(items);
        if (cart?.getSectionsToRender) {
          payload.sections = cart.getSectionsToRender().map((section) => section.id);
          payload.sections_url = window.location.pathname;
          cart.setActiveElement?.(document.activeElement);
        }
        this.addGroupButton.disabled = true;
        this.addGroupButton.classList.add('loading');
        this.setStatus(this.labels.loading);
        try {
          const endpoint = window.routes?.cart_add_url || `${window.Shopify?.routes?.root || '/'}cart/add.js`;
          const response = await fetch(endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
            body: JSON.stringify(payload),
          });
          const data = await response.json();
          if (!response.ok || data.status) throw new Error(data.description || data.message || this.labels.error);
          this.resolveCartLinesUpdate(linesUpdateDeferred);
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
            await publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'group-order-builder',
              productVariantId: String(items[0].id),
              cartData: data,
            });
          }
          const shirtCount = this.items.reduce((sum, item) => sum + item.quantity, 0);
          this.items = [];
          this.renderRows();
          this.setStatus(`${shirtCount} ${this.labels.added}`);
          if (cart?.renderContents) {
            cart.classList.remove('is-empty');
            cart.renderContents(data);
          } else {
            window.location.assign(window.routes?.cart_url || `${window.Shopify?.routes?.root || '/'}cart`);
          }
        } catch (error) {
          console.error(error);
          linesUpdateDeferred?.reject(error);
          this.setStatus(error.message || this.labels.error, true);
        } finally {
          this.addGroupButton.disabled = false;
          this.addGroupButton.classList.remove('loading');
        }
      }

      createCartLinesUpdateEvent(items) {
        const { CartLinesUpdateEvent } = window.StandardEvents || {};
        if (!CartLinesUpdateEvent) return null;
        const deferred = CartLinesUpdateEvent.createPromise();
        this.dispatchEvent(new CartLinesUpdateEvent({
          action: 'add',
          context: 'product',
          lines: items.map((item) => ({ merchandiseId: String(item.id), quantity: item.quantity })),
          promise: deferred.promise,
        }));
        return deferred;
      }

      resolveCartLinesUpdate(deferred) {
        if (!deferred) return;
        const { CartLinesUpdateEvent } = window.StandardEvents || {};
        if (!CartLinesUpdateEvent) return;
        const pendingCart = typeof CartItems !== 'undefined'
          ? CartItems.fetchCartData()
          : fetch(`${window.routes?.cart_url || '/cart'}.json`).then((response) => response.json());
        pendingCart
          .then((cart) => {
            if (!cart?.currency) throw new Error('Missing currency in cart response.');
            deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart) });
          })
          .catch((error) => deferred.reject(error));
      }

      setStatus(message, error = false) {
        this.status.textContent = message;
        if (error) this.status.dataset.error = 'true';
        else delete this.status.dataset.error;
      }
    },
  );
}
